import { Tenant } from '../models/tenant.model';
import { getToken, validateAndExtractData } from './api.base.service';

export const getTenant = async (id: string): Promise<Tenant> => {
  const response = await fetch(
    `${process.env.REACT_APP_REAL_GENIUS_REST}tenant/${id}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        authorization: getToken()
      }
    }
  );
  const tenant: Tenant = await validateAndExtractData(response);
  return tenant;
};

export const getTenantPublic = async (slug: string): Promise<Tenant> => {
  const response = await fetch(
    `${process.env.REACT_APP_REAL_GENIUS_REST}tenant/${slug}/limited`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    }
  );
  const tenant: Tenant = await validateAndExtractData(response);
  return tenant;
};

export const getTenants = async (): Promise<Tenant[]> => {
  const response = await fetch(
    `${process.env.REACT_APP_REAL_GENIUS_REST}tenant`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        authorization: getToken()
      }
    }
  );
  const tenants: Tenant[] = await validateAndExtractData(response);
  return tenants;
};

export const addPartner = async (
  id: string,
  partnerId: string
): Promise<Tenant> => {
  const response = await fetch(
    `${process.env.REACT_APP_REAL_GENIUS_REST}tenant/${id}/partners/add`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        authorization: getToken()
      },
      body: JSON.stringify({ partnerId })
    }
  );
  const tenant: Tenant = await validateAndExtractData(response);
  return tenant;
};

export const updateTenant = async (
  id: string,
  tenantData: Partial<Tenant>
): Promise<Tenant> => {
  const data = { ...tenantData };
  delete data._id;

  const response = await fetch(
    `${process.env.REACT_APP_REAL_GENIUS_REST}tenant/${id}`,
    {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        authorization: getToken()
      },
      body: JSON.stringify(data)
    }
  );
  const tenant: Tenant = await validateAndExtractData(response);
  return tenant;
};
